import * as React from "react";
import { AnalyticsTrigger } from "../../helpers/analytics/analytics-trigger/analytics-trigger.mjs";
import { Icon } from "../../icon/icon/icon.mjs";
import { useLabels } from "../../helpers/label-provider/use-labels.mjs";
import { SuggestionField } from "../suggestionfield/suggestionfield.mjs";
import { TextField } from "../textfield/textfield.mjs";
const isSuggestionField = (props) => {
  return Object.prototype.hasOwnProperty.call(props, "items");
};
const BEM = (props) => {
  const classArray = ["search"];
  if (props.hideLabel) {
    classArray.push("search--no-label-" + props.hideLabel);
  }
  if (props.size) {
    classArray.push("search--" + props.size);
  }
  if (props.className) {
    classArray.push(props.className);
  }
  return classArray.join(" ");
};
const Search = (props) => {
  return /* @__PURE__ */ React.createElement(
    AnalyticsTrigger,
    {
      trigger: {
        callback: "onSubmit",
        id: "Search - Submit - ".concat(props.id),
        elementType: "search",
        interactionType: "submit",
        elementId: props.id
      }
    },
    /* @__PURE__ */ React.createElement(SearchInner, { ...props })
  );
};
const SearchInner = (props) => {
  const { formAttributes, searchRef, onSubmit, isDisabled, placeholder, label, inputRef, isClearable = true, focusOnMount, submitButtonText, ...rest } = props;
  const input = React.useRef(null);
  const labels = useLabels();
  const setInputRef = (el) => {
    input.current = el;
    if (inputRef) {
      inputRef(el);
    }
  };
  React.useEffect(() => {
    if (focusOnMount && input.current) {
      input.current.focus();
    }
  }, [focusOnMount]);
  const inputProps = {
    ...rest,
    className: "search__textfield",
    inputClass: "search__input",
    inputRef: setInputRef,
    isClearable,
    label: placeholder != null ? placeholder : label,
    isDisabled,
    contentRenderer: () => /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "search__action",
        type: "submit",
        disabled: isDisabled,
        onClick: (e) => {
          e.stopPropagation();
        }
      },
      /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, submitButtonText != null ? submitButtonText : labels.get("search.submit")),
      /* @__PURE__ */ React.createElement(Icon, { modifiers: "#search", className: "search__action-icon" })
    )
  };
  return /* @__PURE__ */ React.createElement("form", { ...formAttributes, className: BEM(props), ref: searchRef, onSubmit }, isSuggestionField(props) ? /* @__PURE__ */ React.createElement(SuggestionField, { ...inputProps }) : /* @__PURE__ */ React.createElement(TextField, { ...inputProps }));
};
export {
  Search
};
